import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import { MulticriteriaTypesMap } from '../../../../enuns/AfterSales/multicriteriaTypes.enum';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class MulticriteriaAfterSalesFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const multicriteriaTypes = [
            { nome: translate(`Common.${MulticriteriaTypesMap.autoParts}`), value: "Auto Peças" },
            { nome: translate(`Common.${MulticriteriaTypesMap.tireRetail}`), value: "Pneus Varejo"},
            { nome: translate(`Common.${MulticriteriaTypesMap.tireTruck}`), value: "Pneus Pesado" },
            { nome: 'MultiTipo', value: "MultiTipo" },
        ];

        const scoreRanges = environment.get('CONFIG.FILTERS.SCORE_RANGES');

        let data = [];

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showClassificationFilter)) {
            data.push(
                {
                    name: 'multicriteriaTypes',
                    position: 1,
                    data: multicriteriaTypes,
                    fields: [
                        {
                            title: 'Classificação',
                            name: 'multicriteriaTypes',
                            value: 'value',
                            text: 'nome',
                            type: 'multiselect',
                            skipAll: true
                        }
                    ]
                });
        }

        data.push(
            {
                name: 'scoreRanges',
                position: 2,
                data: scoreRanges,
                fields: [
                    {
                        title: 'Score',
                        name: 'scoreRanges',
                        value: 'value',
                        text: 'name',
                        type: 'multiselect',
                        skipAll: true
                    }
                ]
            });

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/multicriteriaAfterSales.factory.js